import { createFileRoute } from '@tanstack/react-router'
import { Button } from 'shadcn-ui';
import * as Sentry from '@sentry/react';

export const Route = createFileRoute('/plain')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Button
    onClick={() => {
      throw new Error('This is your first error!');
    }}
  >
    Break the world
  </Button>
}
